module.exports = __webpack_public_path__ + "img/titleTwo5.15421ed2.png";